export const tableData = [
  { name: "School(1 to 8)", amount: "Up to Rs.10,000 / Year" },
  { name: "High School(9 to 12)", amount: "Up to Rs.20,000 / Year" },
  { name: "College", amount: "Up to Rs.50,000 / Year" },
  { name: "Professional Course", amount: "Up to Rs.80,000 / Year" },
];
